import { refs, domReady } from '../modules/utils.js';

class InfoBox3 extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.open?.addEventListener('pointerup', () => {
      this.toggleAttribute('data-overlay', true);
    });
    this.refs.close?.addEventListener('pointerup', () => {
      this.toggleAttribute('data-overlay', false);
    });
  }
}

customElements.define('info-box-3', InfoBox3);
